import { ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';
import { ItensGroupExitInterviewModel } from './itensGroupExitInterview.model';
import { formatDate } from '@angular/common';

export class TypeExitInverviewModel extends Model implements IModel<TypeExitInverviewModel> {
  public name: string = '';
  public companyGroupId: string | undefined = undefined;
  public introductionContent: string = '';
  public conclusionContent: string = '';
  public groups: ItensGroupExitInterviewModel[] = [];
  public type: string | undefined = undefined;

  public get lastModification(): string {
    const date =
      !this.changeDate ||
      this.changeDate === '0001-01-01T00:00:00.000' ||
      this.changeDate === '-infinity'
        ? this.creationDate
        : this.changeDate;

    return formatDate(date, 'dd/MM/yyyy HH:mm', 'pt-BR');
  }

  static create(input: any): TypeExitInverviewModel {
    return ObjectMapper.deserialize<TypeExitInverviewModel>(TypeExitInverviewModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
